import React from 'react';
import PropTypes from 'prop-types';

import Paper from '@mui/material/Paper';

/* Composants customisés partagés*/
import DepotGestionAutocomplete from 'components/Shared/DepotGestionAutocomplete';



const ReclamationsRetourPlateformeSearchFilters = ({ criteres, onChangeDepotGestion }) => {

    let depots = [];

    let utilisateur = JSON.parse(localStorage.getItem('utilisateur'));

    if (!utilisateur.administrateur) {
        if (utilisateur.depot && utilisateur.depot.code != '01' && utilisateur.depot.code != '70') {
            return null; // Pas de choix, le dépot de l'utilisateur est déjà selectionné
        }
        depots = utilisateur.depots.filter(x => x.code != '01' && x.code != '70');
        if (depots.length === 1) {
            return null; // Pas de choix, le seul des dépots
        }
    }

    return (
        <Paper sx={{marginBottom: 3, padding: 1}}>
            <DepotGestionAutocomplete
                value={criteres.codeDepot}
                onChange={onChangeDepotGestion}
                magasinsSeulement
                required
                autoFocus
                label="Sélectionner un magasin :"
                modeTri={1}
                depotsGestion={depots}
            />
        </Paper>
    );
}

ReclamationsRetourPlateformeSearchFilters.propTypes = {
    criteres: PropTypes.object.isRequired,
    onChangeDepotGestion: PropTypes.func.isRequired, 
};

export default ReclamationsRetourPlateformeSearchFilters;